<template>
  <div class="harvest-container">
    <Header />
    <!-- 顶部筛选：数据粒度、日期范围、大棚选择与操作按钮 -->
    <div class="databox">
      <div class="dataTop">
        <div class="top-add">
          <el-button type="primary" v-if="getAllMenuCodes.includes('0I2QQ5wt')" icon="el-icon-plus"
            @click="handleAdd">采收数据</el-button>
          <el-button type="primary" v-if="getAllMenuCodes.includes('UdHZsbBZ')" icon="el-icon-view"
            @click="handlePartition">商品分拣</el-button>
        </div>
        <div class="top-filters">
          <!-- 自定义日/月切换（不使用 el-radio-group），绑定 timeDimension: 'DAILY' | 'MONTHLY' -->
          <div class="time-dimension">
            <button type="button" :class="['time-btn', { active: timeDimension === 'DAILY' }]"
              @click="setTimeDimension('DAILY')">
              日数据
            </button>
            <button type="button" :class="['time-btn', { active: timeDimension === 'MONTHLY' }]"
              @click="setTimeDimension('MONTHLY')">
              月数据
            </button>
          </div>

          <div class="time-label">时间：</div>
          <el-date-picker v-model="dateRange" :type="timeDimension === 'MONTHLY' ? 'monthrange' : 'daterange'"
            :start-placeholder="timeDimension === 'MONTHLY' ? '开始月份' : '开始时间'
              " :end-placeholder="timeDimension === 'MONTHLY' ? '结束月份' : '结束时间'
                " :value-format="timeDimension === 'MONTHLY' ? 'yyyy-MM' : 'yyyy-MM-dd'
                  " align="right" size="small" :picker-options="pickerOptions" @change="onDateRangeChange" />
          <div class="time-label">当前大棚：</div>
          <el-select v-model="greenhouseId" placeholder="请选择" style="width: 220px" size="small" clearable
            @change="onGreenhouseChange">
            <el-option v-for="item in greenhouseOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>

          <el-button type="primary" size="small" @click="onQuery" style="margin-left: 8px">查询</el-button>
          <el-button size="small" @click="onReset" style="margin-left: 6px">刷新/重置</el-button>
        </div>
      </div>
      <div class="harvest-content">
        <!-- 统计卡片 -->
        <div class="stats-section">
          <div :class="[
            'stat-card',
            { 'donut-card': idx === 3, 'summary-card': idx === 2 },
          ]" v-for="(stat, idx) in stats" :key="idx">
            <!-- 卡片主体：左侧为文字（标题在上，数值在中），右侧为图标或第4卡的3D容器 -->
            <div class="stat-header">
              <div class="stat-info" v-if="idx !== 3">
                <div class="stat-label">
                  {{ stat.label }}{{ stat.unit || "" }}
                </div>
                <!-- 第4张卡不显示大号数值，改为展示右侧 3D 图 -->
                <div class="stat-value" v-if="idx !== 3">{{ stat.value }}</div>
              </div>

              <!-- 普通卡片图标（右侧） -->
              <div class="stat-icon-wrapper" v-if="idx !== 3">
                <div class="stat-icon-bg"></div>
                <div class="stat-icon">
                  <img :src="stat.icon" alt="" />
                </div>
              </div>

              <!-- 第4张卡：在右侧显示 3D 容器，隐藏默认图标 -->
              <div class="stat-icon-wrapper donut-wrapper" v-if="idx === 3">
                <div id="cityGreenLand-charts" style="width: 400px; height: 160px"></div>
              </div>
            </div>

            <!-- 底部状态行，仅普通带 statusItems 的卡片显示 -->
            <div class="stat-footer" v-if="stat.statusItems && stat.statusItems.length && idx !== 3">
              <span class="status-item" :class="item.type" v-for="(item, idy) in stat.statusItems" :key="idy">
                <span class="status-value">{{ item.value }}</span>
                <span class="status-label">{{ item.label }}</span>
              </span>
            </div>
          </div>
        </div>

        <!-- 主要区域：左表 右图 -->
        <div class="main-content">
          <div class="left-panel panel-card">
            <div class="section-title">各大棚采摘进度</div>
            <div class="harvest-table">
              <table>
                <thead>
                  <tr>
                    <th>大棚编号</th>
                    <th>产品名称</th>
                    <th>预计产量(kg)</th>
                    <th>实际产量(kg)</th>
                    <th>完成率</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in harvestList" :key="index">
                    <td>{{ row.greenhouseName }}</td>
                    <td>{{ row.varietyName }}</td>
                    <td>{{ row.estimatedOutput }}</td>
                    <td>{{ row.actualOutput }}</td>
                    <td>
                      <div class="progress-wrap">
                        <div class="progress-bar" :style="{
                          width: `${row.completionRate * 100 >= 100
                            ? 100
                            : Math.round(row.completionRate * 100)
                            }%`,
                        }"></div>
                        <span class="progress-text">{{ (row.completionRate * 100).toFixed(2) }}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="table-empty" v-if="!harvestList || harvestList.length === 0">
                <img :src="emptyImage" alt="暂无数据" />
                <div class="empty-text">暂无采收数据</div>
              </div>
            </div>
          </div>

          <div class="right-panel panel-card">
            <div class="section-title">商品果趋势</div>
            <div class="chart-area">
              <!-- ECharts 折线图容器 -->
              <div ref="lineChart" class="line-chart" :class="{ 'chart-hidden': !hasChartData }"></div>
              <!-- 空状态 -->
              <div v-if="!hasChartData" class="table-empty chart-overlay">
                <img :src="emptyImage" alt="暂无数据" />
                <div class="empty-text">暂无商品果趋势数据</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import Header from "@/views/Header.vue";
import tip1 from "@/assets/img/harvest/tip1.png";
import tip2 from "@/assets/img/harvest/tip2.png";
import tip3 from "@/assets/img/harvest/tip3.png";
import emptyImage from "@/assets/img/workbench/empty.png";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import router from "../../../router";
import * as echarts from "echarts";
import "echarts-gl";

export default {
  name: "TechFarmHarvest",
  components: {
    Header,
  },
  computed: {
    ...mapGetters("user", ["getAllMenuCodes"]),
    // 日期选择器限制选项
    pickerOptions() {
      if (this.timeDimension === "DAILY") {
        // 日数据：允许选择任意日期，但范围不能超过60天
        return {
          onPick: ({ maxDate, minDate }) => {
            if (minDate && maxDate) {
              const diffTime = Math.abs(maxDate - minDate);
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // 包含起始日期
              if (diffDays > 60) {
                this.$message.warning("日数据最多只能选择60天范围，请重新选择");
                // 清空选择，让用户重新选择
                this.$nextTick(() => {
                  this.dateRange = [];
                });
              }
            }
          },
        };
      } else {
        // 月数据：允许选择任意月份，但范围不能超过12个月
        return {
          onPick: ({ maxDate, minDate }) => {
            if (minDate && maxDate) {
              const diffMonths =
                (maxDate.getFullYear() - minDate.getFullYear()) * 12 +
                (maxDate.getMonth() - minDate.getMonth()) +
                1; // 包含起始月份
              if (diffMonths > 12) {
                this.$message.warning(
                  "月数据最多只能选择12个月范围，请重新选择"
                );
                // 清空选择，让用户重新选择
                this.$nextTick(() => {
                  this.dateRange = [];
                });
              }
            }
          },
        };
      }
    },
  },
  data() {
    return {
      stats: [
        { icon: tip1, value: 24, label: "大棚数量", unit: "", statusItems: [] },
        {
          icon: tip2,
          value: "12,560",
          label: "预计总产量",
          unit: " (kg)",
          statusItems: [],
        },
        {
          icon: tip3,
          value: "12,200",
          label: "总采收量",
          unit: "(kg)",
          statusItems: [],
        },
        {
          icon: "",
          value: "81%",
          label: "商品果占比",
          unit: "",
          statusItems: [
            { label: "今日", value: 81, type: "normal" },
            { label: "本周", value: 76, type: "locked" },
          ],
        },
      ],
      harvestList: [],
      emptyImage,

      // 分页相关
      page: 1,
      pageSize: 9,
      total: 0,

      lineChartInstance: null,
      isUpdatingChart: false, // 防止图表并发更新
      chartUpdateTimer: null, // 图表更新定时器
      hasChartData: false, // 标记是否有图表数据

      // 3D 分级数据（可由后端接口替换）
      gradeData: [
        { name: "小果(精品果)", value: 120, color: 0x06a6ff },
        { name: "中果(优质果)", value: 180, color: 0x06d6a0 },
        { name: "大果(特级果)", value: 260, color: 0xffd166 },
      ],
      // 3D饼图数据（基于gradeData生成）
      optionData: [],
      // 来自后端的大棚选择数据（复用 tesk.vue 的接口）
      greenhouseOptions: [],
      greenhouseId: "",
      greenhouseName: "",
      // 顶部筛选状态
      // 使用后端约定字段 timeDimension，取值 'DAILY' 或 'MONTHLY'
      timeDimension: "",
      dateRange: [], // [start, end]，格式 yyyy-MM-dd，默认当天
    };
  },
  mounted() {
    // 设置默认时间维度为日数据和最近30天
    this.timeDimension = "";
    const now = dayjs();
    this.dateRange = [];

    // 只读取大棚列表，不自动请求其他数据
    this.getGreenhouseName();
    // 初始化3D图表（显示空状态）
    this.init3DChart();
    this.onQuery();
  },

  beforeDestroy() {
    this.disposeLineChart();
  },

  methods: {
    // 初始化3D图表
    init3DChart() {
      this.$nextTick(() => {
        // 基于gradeData生成optionData

        this.optionData = this.gradeData.map((item) => ({
          name: item.name,
          value: item.value,
          boxes: item.boxes,
          itemStyle: {
            color: `#${item.color.toString(16).padStart(6, "0")}`,
          },
        }));
        // 如果所有数据为 0 或者没有数据，显示空状态文本并跳过 3D 绘制以避免除0错误
        const total = this.optionData.reduce(
          (s, it) => s + (Number(it.value) || 0),
          0
        );
        const chartContainer = document.getElementById("cityGreenLand-charts");
        if (!chartContainer) return;

        if (!total) {
          // 若已有实例，先 dispose 清理
          const existing = echarts.getInstanceByDom(chartContainer);
          if (existing) {
            echarts.dispose(chartContainer);
          }
          // 渲染一个简单的空状态（居中文本），并清空原有 option
          const myChart = echarts.init(chartContainer);
          const emptyOption = {
            title: {
              text: "商品果占比",
              left: "center",
              top: 8,
              left: 11,
              textStyle: {
                color: "#fff",
                fontSize: 24,
                fontWeight: "500",
              },
            },
            graphic: [
              {
                type: "text",
                left: "50%",
                top: "50%",
                style: {
                  text: "暂无数据",
                  fill: "#9fb2c8",
                  font: "14px Microsoft YaHei",
                  align: "center",
                },
                z: 0,
              },
            ],
          };
          myChart.setOption(emptyOption, true);
          return;
        }

        // 有有效数据则先清理已有实例，再继续绘制 3D 饼图
        const existing = echarts.getInstanceByDom(chartContainer);
        if (existing) {
          echarts.dispose(chartContainer);
        }
        this.init();
      });
    },

    // 初始化3D饼图
    init() {
      //构建3d饼状图
      let myChart = echarts.init(
        document.getElementById("cityGreenLand-charts")
      );
      // 传入数据生成 option
      this.option = this.getPie3D(this.optionData, 0.8);
      // 添加图表标题（商品果占比），居中显示于上方
      this.option.title = {
        text: "商品果占比",
        left: "center",
        top: 8,
        left: 11,
        textStyle: {
          color: "#fff",
          fontSize: 24,
          fontWeight: "500",
        },
      };
      myChart.setOption(this.option);
      //是否需要label指引线，如果要就添加一个透明的2d饼状图并调整角度使得labelLine和3d的饼状图对齐，并再次setOption
      // 计算总值用于百分比计算
      const totalValue = this.optionData.reduce(
        (sum, item) => sum + item.value,
        0
      );
      this.option.series.push({
        name: "pie2d",
        type: "pie",
        // 指引线可显示，标签使用自定义样式；同时禁用交互 hover/tooltip
        labelLine: {
          show: true,
        },
        startAngle: -10, // 起始角度设为90度，从12点钟方向开始，与3D饼图对齐
        clockwise: false, //饼图的扇区是否是顺时针排布。用于与3D对齐（已移除，与3D默认配置保持一致）
        radius: ["50%", "50%"],
        center: ["50%", "50%"],
        data: this.optionData,
        itemStyle: {
          opacity: 1,
        },
        // 禁用系列交互（移除 hover 效果 & tooltip）
        silent: true,
        hoverAnimation: false,
        emphasis: {
          // 禁用 emphasis 带来的放大/高亮
          scale: false,
        },
        tooltip: {
          show: false,
        },
        // 自定义外部 label：第一行为大号蓝色“占比xx%”，第二行为白色名称+数值（如 中果(优质果)100kg）
        label: {
          show: true,
          position: "outside",
          align: "center",
          formatter: (params) => {
            const percent = Math.round((params.value / totalValue) * 100);
            // 在占比与信息之间插入分割线（使用文本线条）
            return `{percent|占比${percent}%}\n{boxes|盒数${params.data.boxes}}\n{sep|────────────────}\n{info|${params.name}${params.value}kg}`;
          },
          rich: {
            percent: {
              color: "#2f6bff",
              fontSize: 12,
              fontWeight: "bold",
              lineHeight: 15,
              align: "center",
            },
            boxes: {
              color: "#06d6a0",
              fontSize: 12,
              fontWeight: "normal",
              lineHeight: 14,
              align: "center",
            },
            sep: {
              color: "#ffffff",
              fontSize: 10,
              lineHeight: 10,
              align: "center",
            },
            info: {
              color: "#ffffff",
              fontSize: 12,
              align: "center",
            },
          },
        },
        // 提高渲染层级以避免被 3D 或其他图层遮挡
        z: 0,
        zlevel: 2,
      });
      myChart.setOption(this.option);
      this.bindListen(myChart);
    },

    // 构建通用的查询参数
    buildQueryParams() {
      const params = {
        greenhouseId: this.greenhouseId || undefined,
      };

      // 如果有日期范围则加入参数
      if (this.dateRange && this.dateRange.length === 2) {
        let startTime = this.dateRange[0];
        let endTime = this.dateRange[1];

        if (this.timeDimension === "MONTHLY") {
          // 月数据：月份格式为 YYYY-MM，需要转换为该月的第一天和最后一天
          const startDate = new Date(startTime + "-01");
          const endDate = new Date(endTime + "-01");

          startTime = `${startDate.getFullYear()}-${String(
            startDate.getMonth() + 1
          ).padStart(2, "0")}-01`;

          // 获取该月的最后一天
          const lastDayOfMonth = new Date(
            endDate.getFullYear(),
            endDate.getMonth() + 1,
            0
          );
          endTime = `${lastDayOfMonth.getFullYear()}-${String(
            lastDayOfMonth.getMonth() + 1
          ).padStart(2, "0")}-${String(lastDayOfMonth.getDate()).padStart(
            2,
            "0"
          )}`;
        }

        params.startTime = startTime;
        params.endTime = endTime;
      }

      // 加入数据粒度字段（后端按 timeDimension 处理）
      if (this.timeDimension) {
        params.timeDimension = this.timeDimension;
      }

      return params;
    },
    async fetchStats() {
      try {
        const params = this.buildQueryParams();
        const res = await axios.post(
          baseUrl + "/api/digital-farming/harvest/data/statistics",
          params
        );
        if (res && res.code === 200 && res.data) {
          // 基本数值赋值
          const estimated = res.data.sumEstimatedOutput || 0;
          const actual = res.data.sumOutput || 0;
          this.stats[0].value = res.data.greenhouseCount || 0;
          this.stats[1].value = estimated;
          this.stats[2].value = actual;

          // 计算较预估相关指标：
          // vsEstimated: 实际 - 预估（带正负号）
          // ratioPercent: 实际 / 预估 * 100% （若预估为0显示 --）
          const vsEstimated = actual - estimated;
          const ratioPercent =
            estimated !== 0
              ? ((actual / estimated) * 100).toFixed(2) + "%"
              : "--";

          // 将这些信息作为 statusItems 挂载到“总采收量”卡片（索引 2）
          // 仅显示单个百分比项（如图示），标签为“较预估”
          this.stats[2].statusItems = [
            {
              label: "较预估",
              value: ratioPercent,
              type: vsEstimated >= 0 ? "normal" : "locked",
            },
          ];

          // 如果后端返回了分规格产量列表（specOutputList），将其作为饼图的数据源
          // 后端字段示例：[{ specSize: "LARGE", output: 331 }, ...]
          if (
            res.data.specOutputList &&
            Array.isArray(res.data.specOutputList)
          ) {
            const specList = res.data.specOutputList;
            // 映射关系：LARGE -> 大果(特级果), MEDIUM -> 中果(优质果), SMALL -> 小果(精品果)（不包含BASKET篮装草莓）
            const sizeMap = {
              LARGE: { name: "大果(特级果)", color: 0xffd166 },
              SMALL: { name: "小果(精品果)", color: 0x06a6ff },
              MEDIUM: { name: "中果(优质果)", color: 0x06d6a0 },
            };
            const order = ["LARGE", "SMALL", "MEDIUM"];

            this.gradeData = order.map((key) => {
              const found = specList.find((s) => s.specSize === key);
              return {
                name: sizeMap[key].name,
                value: found ? Number(found.output || 0) : 0,
                color: sizeMap[key].color,
                boxes: found ? Number(found.boxes || 0) : 0,
              };
            });
            console.log("gradeData", this.gradeData);
            this.init3DChart();
          }
        }
      } catch (error) {
        console.error("获取采收统计失败:", error);
      }
    },
    async fetchHarvestList() {
      try {
        const params = this.buildQueryParams(true);
        const res = await axios.post(
          baseUrl + "/api/digital-farming/harvest/data/harvest-progress",
          params
        );
        console.log("采摘进度", res);

        if (res && res.code === 200 && res.data) {
          this.harvestList = res.data;
        }
      } catch (error) {
        console.error("获取采收列表失败:", error);
      }
    },
    // 更新分规格商品果趋势数据（用于已初始化的图表）
    async fetchSizeTrend() {
      // 防止并发更新
      if (this.isUpdatingChart) {
        return;
      }
      this.isUpdatingChart = true;

      try {
        const params = this.buildQueryParams();
        const res = await axios.post(
          baseUrl + "/api/digital-farming/harvest/data/size-trend",
          params
        );

        if (
          res &&
          res.code === 200 &&
          Array.isArray(res.data) &&
          res.data.length > 0
        ) {
          const apiList = res.data; // [{ specSize: "LARGE", trend: [{x,y}, ...] }, ...]
          // 保持固定顺序：LARGE(大果(特级果))、MEDIUM(中果(优质果))、SMALL(小果(精品果)) (过滤掉BASKET篮装草莓和INFERIOR次果)
          const order = ["SMALL", "LARGE", "MEDIUM"];

          // 收集所有 x 轴刻度（去重并按字符串升序）
          const xSet = new Set();
          apiList.forEach((it) => {
            if (Array.isArray(it.trend)) {
              it.trend.forEach((t) => xSet.add(t.x));
            }
          });
          const xAxisData = Array.from(xSet).sort();

          // 为每个规格生成完整的系列配置（按照 xAxisData 顺序填充 y，缺失为 0）
          const nameMap = {
            LARGE: "大果(特级果)",
            MEDIUM: "中果(优质果)",
            SMALL: "小果(精品果)",
          };
          const colorMap = {
            LARGE: "#ffd166",
            MEDIUM: "#06d6a0",
            SMALL: "#06a6ff",
          };

          const seriesData = order.map((key) => {
            const found = apiList.find((it) => it.specSize === key);
            const yMap = new Map();
            if (found && Array.isArray(found.trend)) {
              found.trend.forEach((t) => yMap.set(t.x, Number(t.y) || 0));
            }
            const dataArr = xAxisData.map((x) =>
              yMap.has(x) ? yMap.get(x) : 0
            );
            return {
              name: nameMap[key],
              type: "line",
              smooth: 0.4,
              showSymbol: true,
              symbol: "circle",
              symbolSize: 6,
              lineStyle: { color: colorMap[key], width: 2 },
              itemStyle: { color: colorMap[key] },
              data: dataArr,
            };
          });

          // 检查是否有有效数据并更新状态
          this.hasChartData =
            xAxisData.length > 0 &&
            seriesData.some(
              (series) =>
                series.data &&
                series.data.length > 0 &&
                series.data.some((value) => value > 0)
            );

          // 确保图表实例已初始化
          if (!this.lineChartInstance) {
            const el = this.$refs.lineChart;
            if (el) {
              this.lineChartInstance = echarts.init(el);
              window.addEventListener("resize", this.onLineChartResize);
            }
          }

          // 使用防抖更新图表，避免频繁调用 setOption
          this.debouncedUpdateChart(xAxisData, seriesData);
        } else {
          // API返回空数组或无效数据时设置为空状态
          this.hasChartData = false;
        }
      } catch (err) {
        // API调用失败时设置为空状态
        this.hasChartData = false;
      } finally {
        // 重置更新标志
        this.isUpdatingChart = false;
      }
    },
    handleAdd() {
      router.push("/techFarm/harvest/add");
    },
    handlePartition() {
      router.push("/techFarm/harvest/partition");
    },
    async getGreenhouseName() {
      try {
        const greenhouseRes = await axios.post(
          baseUrl + "/api/basic/greenhouse/selection?enableStatus=-1"
        );
        if (
          greenhouseRes &&
          greenhouseRes.code === 200 &&
          Array.isArray(greenhouseRes.data)
        ) {
          this.greenhouseOptions = greenhouseRes.data.map((item) => ({
            label: item.serialNumber,
            value: item.id,
          }));
          // 不设置默认大棚，让用户主动选择
        }
      } catch (err) {
        console.error("获取大棚列表失败:", err);
      }
    },
    onDateRangeChange(dateRange) {
      if (!dateRange || dateRange.length !== 2) return;

      let isValid = true;

      if (this.timeDimension === "DAILY") {
        // 日数据：验证日期范围不超过60天
        const startDate = new Date(dateRange[0]);
        const endDate = new Date(dateRange[1]);
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // 包含起始日期

        if (diffDays > 60) {
          this.$message.warning("日数据最多只能选择60天范围，请重新选择");
          this.dateRange = [];
          return;
        }
      } else {
        // 月数据：验证月份范围不超过12个月
        const startMonth = new Date(dateRange[0] + "-01");
        const endMonth = new Date(dateRange[1] + "-01");
        const diffMonths =
          (endMonth.getFullYear() - startMonth.getFullYear()) * 12 +
          (endMonth.getMonth() - startMonth.getMonth()) +
          1; // 包含起始月份

        if (diffMonths > 12) {
          this.$message.warning("月数据最多只能选择12个月范围，请重新选择");
          this.dateRange = [];
          return;
        }
      }

      // 日期范围有效，触发数据刷新
      this.onQuery();
    },
    onGreenhouseChange(val) {
      this.greenhouseName =
        this.greenhouseOptions.find((it) => it.value === val)?.label || "";
      // 选择大棚后刷新列表与统计
      this.fetchStats();
      this.fetchHarvestList();
      this.fetchSizeTrend();
    },
    setTimeDimension(value) {
      if (this.timeDimension === value) return;
      this.timeDimension = value;

      // 根据时间维度同步更新日期范围
      if (value === "DAILY") {
        // 日数据：设置为最近30天
        const now = dayjs();
        const thirtyDaysAgo = now.subtract(29, "day");
        this.dateRange = [
          thirtyDaysAgo.format("YYYY-MM-DD"),
          now.format("YYYY-MM-DD"),
        ];
      } else if (value === "MONTHLY") {
        // 月数据：设置为最近6个月
        const now = dayjs();
        const sixMonthsAgo = now.subtract(5, "month");
        this.dateRange = [
          sixMonthsAgo.format("YYYY-MM"),
          now.format("YYYY-MM"),
        ];
      }

      // 切换后触发刷新
      this.fetchStats();
      this.fetchHarvestList();
      this.fetchSizeTrend();
    },
    // 查询方法
    onQuery() {
      this.fetchStats();
      this.fetchHarvestList();
      this.fetchSizeTrend();
    },
    // 重置/刷新方法
    onReset() {
      // 重置筛选条件
      this.timeDimension = "";
      this.greenhouseId = "";
      this.greenhouseName = "";
      // 重置日期为最近30天
      this.dateRange = [];
      // 重置分页
      // 重新加载数据
      this.fetchStats();
      this.fetchHarvestList();
      this.fetchSizeTrend();
    },

    /* ----------------------------
       ECharts 折线图（商品果趋势）- 整合初始化和数据更新
       ---------------------------- */
    async initAndUpdateLineChart() {
      const el = this.$refs.lineChart;
      if (!el) return;

      // 防止并发更新
      if (this.isUpdatingChart) {
        return;
      }
      this.isUpdatingChart = true;

      try {
        // 初始化图表实例
        if (!this.lineChartInstance) {
          this.lineChartInstance = echarts.init(el);
          window.addEventListener("resize", this.onLineChartResize);
        }

        // 获取数据
        const params = this.buildQueryParams();
        const res = await axios.post(
          baseUrl + "/api/digital-farming/harvest/data/size-trend",
          params
        );

        let xAxisData = [];
        let seriesData = [];

        if (res && res.code === 200 && Array.isArray(res.data)) {
          const apiList = res.data; // [{ specSize: "LARGE", trend: [{x,y}, ...] }, ...]
          // 保持固定顺序：LARGE(大果(特级果))、MEDIUM(中果(优质果))、SMALL(小果(精品果)) (过滤掉INFERIOR次果)
          const order = ["SMALL", "LARGE", "MEDIUM"];
          const nameMap = {
            LARGE: "大果(特级果)",
            MEDIUM: "中果(优质果)",
            INFERIOR: "次果",
            SMALL: "小果(精品果)",
          };
          const colorMap = {
            LARGE: "#ffd166",
            MEDIUM: "#06d6a0",
            INFERIOR: "#ff7b7b",
            SMALL: "#06a6ff",
          };

          // 收集所有 x 轴刻度（去重并按字符串升序）
          const xSet = new Set();
          apiList.forEach((it) => {
            if (Array.isArray(it.trend)) {
              it.trend.forEach((t) => xSet.add(t.x));
            }
          });
          xAxisData = Array.from(xSet).sort();

          // 为每个规格生成 data 数组（按照 xAxisData 顺序填充 y，缺失为 0）
          seriesData = order.map((key) => {
            const found = apiList.find((it) => it.specSize === key);
            const yMap = new Map();
            if (found && Array.isArray(found.trend)) {
              found.trend.forEach((t) => yMap.set(t.x, Number(t.y) || 0));
            }
            const dataArr = xAxisData.map((x) =>
              yMap.has(x) ? yMap.get(x) : 0
            );
            return {
              name: nameMap[key],
              type: "line",
              smooth: 0.4,
              showSymbol: false,
              lineStyle: { color: colorMap[key], width: 2 },
              itemStyle: { color: colorMap[key] },
              data: dataArr,
            };
          });

          // 检查是否有有效数据
          this.hasChartData =
            xAxisData.length > 0 &&
            seriesData.some(
              (series) =>
                series.data &&
                series.data.length > 0 &&
                series.data.some((value) => value > 0)
            );
        } else {
          // 如果没有数据，设置空状态
          this.hasChartData = false;
          xAxisData = Array.from({ length: 15 }, (_, i) => `${i + 1}日`);
          seriesData = [
            {
              name: "大果(特级果)",
              type: "line",
              smooth: 0.4,
              showSymbol: true,
              symbol: "circle",
              symbolSize: 6,
              lineStyle: { color: "#ffd166", width: 2 },
              itemStyle: { color: "#ffd166" },
              data: [],
            },
            {
              name: "中果(优质果)",
              type: "line",
              smooth: 0.4,
              showSymbol: true,
              symbol: "circle",
              symbolSize: 6,
              lineStyle: { color: "#06d6a0", width: 2 },
              itemStyle: { color: "#06d6a0" },
              data: [],
            },
            {
              name: "次果",
              type: "line",
              smooth: 0.4,
              showSymbol: true,
              symbol: "circle",
              symbolSize: 6,
              lineStyle: { color: "#ff7b7b", width: 2 },
              itemStyle: { color: "#ff7b7b" },
              data: [],
            },
            {
              name: "小果(精品果)",
              type: "line",
              smooth: 0.4,
              showSymbol: true,
              symbol: "circle",
              symbolSize: 6,
              lineStyle: { color: "#06a6ff", width: 2 },
              itemStyle: { color: "#06a6ff" },
              data: [],
            },
          ];
        }

        // 检查是否有有效数据
        this.hasChartData =
          xAxisData.length > 0 &&
          seriesData.some(
            (series) =>
              series.data &&
              series.data.length > 0 &&
              series.data.some((value) => value > 0)
          );

        // 判断x轴数据是否超过7个，决定是否启用数据缩放
        const showDataZoom = xAxisData.length > 7;

        // 构建完整的图表配置
        const option = {
          backgroundColor: "transparent",
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 11, 47, 0.9)",
            borderColor: "rgba(6, 145, 237, 0.6)",
            borderWidth: 1,
            textStyle: {
              color: "#ffffff",
              fontSize: 12,
            },
            axisPointer: {
              type: "cross",
              lineStyle: {
                color: "rgba(6, 145, 237, 0.8)",
                width: 1,
              },
            },
          },
          splitLine: {
            lineStyle: { color: "rgba(255,255,255,0.03)", type: "dashed" },
            show: true,
          },
          legend: {
            data: ["大果(特级果)", "中果(优质果)", "小果(精品果)"],
            top: 10,
            textStyle: { color: "#b6bcc7" },
            itemWidth: 12,
            itemHeight: 2,
            itemGap: 20,
          },
          dataZoom: showDataZoom
            ? [
              {
                type: "slider",
                xAxisIndex: 0,
                start: 0,
                end: Math.min(100, (7 / xAxisData.length) * 100),
                height: 20,
                bottom: 10,
                handleIcon:
                  "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
                handleSize: "80%",
                handleStyle: {
                  color: "#0691ed",
                  shadowBlur: 3,
                  shadowColor: "rgba(0, 0, 0, 0.6)",
                  shadowOffsetX: 2,
                  shadowOffsetY: 2,
                },
                textStyle: {
                  color: "#9fd7ff",
                },
                borderColor: "rgba(6, 145, 237, 0.3)",
                backgroundColor: "rgba(0, 11, 47, 0.8)",
                selectedDataBackground: {
                  lineStyle: {
                    color: "#0691ed",
                  },
                  areaStyle: {
                    color: "rgba(6, 145, 237, 0.2)",
                  },
                },
              },
            ]
            : [],
          grid: {
            left: 40,
            right: 20,
            bottom: showDataZoom ? 60 : 30,
            top: 60,
          },
          xAxis: {
            type: "category",
            data: xAxisData,
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.06)" } },
            axisLabel: { color: "#9fd7ff" },
            splitLine: {
              lineStyle: { color: "rgba(255,255,255,0.03)", type: "dashed" },
            },
          },
          yAxis: {
            type: "value",
            name: "kg",
            nameTextStyle: { color: "#9fbfff" },
            axisLine: { show: false },
            axisLabel: { color: "#9fd7ff" },
            splitLine: {
              lineStyle: { color: "rgba(255,255,255,0.03)", type: "dashed" },
            },
          },
          series: seriesData,
        };

        // 一次性设置完整的图表配置 - 使用异步调用避免主进程冲突
        if (this.lineChartInstance && !this.lineChartInstance.isDisposed()) {
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              try {
                this.lineChartInstance.setOption(option, true);
              } catch (error) {
                console.error("图表初始化失败:", error);
              }
            });
          });
        } else {
          console.error("图表实例不存在或已销毁:", {
            instance: this.lineChartInstance,
            isDisposed: this.lineChartInstance?.isDisposed(),
          });
        }
      } catch (err) {
        console.error("初始化和更新折线图失败:", err);
      } finally {
        // 重置更新标志
        this.isUpdatingChart = false;
      }
    },

    // (kept for back-compatibility) no HTML label overlay in this original variant
    onLineChartResize() {
      if (this.lineChartInstance) this.lineChartInstance.resize();
    },

    disposeLineChart() {
      try {
        window.removeEventListener("resize", this.onLineChartResize);
        if (this.lineChartInstance) {
          this.lineChartInstance.dispose();
          this.lineChartInstance = null;
        }
        // 清除定时器
        if (this.chartUpdateTimer) {
          clearTimeout(this.chartUpdateTimer);
          this.chartUpdateTimer = null;
        }
      } catch (err) {
        console.error("disposeLineChart error:", err);
      }
    },

    // 防抖更新图表数据
    debouncedUpdateChart(xAxisData, seriesData) {
      // 清除之前的定时器
      if (this.chartUpdateTimer) {
        clearTimeout(this.chartUpdateTimer);
      }

      // 设置新的定时器，使用更长的延迟和 nextTick 确保不在主进程中调用
      this.chartUpdateTimer = setTimeout(() => {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            if (
              this.lineChartInstance &&
              !this.lineChartInstance.isDisposed()
            ) {
              try {
                // 判断x轴数据是否超过7个，决定是否启用数据缩放
                const showDataZoom = xAxisData.length > 7;

                this.lineChartInstance.setOption(
                  {
                    legend: {
                      data: ["大果(特级果)", "中果(优质果)", "小果(精品果)"],
                      top: 10,
                      textStyle: { color: "#b6bcc7" },
                      itemWidth: 12,
                      itemHeight: 2,
                      itemGap: 20,
                    },
                    tooltip: {
                      trigger: "axis",
                      backgroundColor: "rgba(0, 11, 47, 0.9)",
                      borderColor: "rgba(6, 145, 237, 0.6)",
                      borderWidth: 1,
                      textStyle: {
                        color: "#ffffff",
                        fontSize: 12,
                      },
                      axisPointer: {
                        type: "cross",
                        lineStyle: {
                          color: "rgba(6, 145, 237, 0.8)",
                          width: 1,
                        },
                      },
                    },
                    dataZoom: showDataZoom
                      ? [
                        {
                          type: "slider",
                          xAxisIndex: 0,
                          start: 0,
                          end: Math.min(100, (7 / xAxisData.length) * 100),
                          height: 20,
                          bottom: 10,
                          handleIcon:
                            "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
                          handleSize: "80%",
                          handleStyle: {
                            color: "#0691ed",
                            shadowBlur: 3,
                            shadowColor: "rgba(0, 0, 0, 0.6)",
                            shadowOffsetX: 2,
                            shadowOffsetY: 2,
                          },
                          textStyle: {
                            color: "#9fd7ff",
                          },
                          borderColor: "rgba(6, 145, 237, 0.3)",
                          backgroundColor: "rgba(0, 11, 47, 0.8)",
                          selectedDataBackground: {
                            lineStyle: {
                              color: "#0691ed",
                            },
                            areaStyle: {
                              color: "rgba(6, 145, 237, 0.2)",
                            },
                          },
                        },
                      ]
                      : [],
                    xAxis: {
                      data: xAxisData,
                      axisLine: {
                        lineStyle: { color: "rgba(255,255,255,0.06)" },
                      },
                      axisLabel: { color: "#9fd7ff" },
                      splitLine: {
                        lineStyle: {
                          color: "rgba(255,255,255,0.03)",
                          type: "dashed",
                        },
                      },
                    },
                    yAxis: {
                      type: "value",
                      name: "kg",
                      nameTextStyle: { color: "#9fbfff" },
                      axisLine: { show: false },
                      axisLabel: { color: "#9fd7ff" },
                      splitLine: {
                        lineStyle: {
                          color: "rgba(255,255,255,0.03)",
                          type: "dashed",
                        },
                      },
                    },
                    series: seriesData,
                  },
                  false // 使用合并模式，保留其他现有配置
                );
              } catch (error) {
                console.error("Chart update failed:", error);
                // 如果失败，重试一次
                setTimeout(() => {
                  if (
                    this.lineChartInstance &&
                    !this.lineChartInstance.isDisposed()
                  ) {
                    try {
                      this.lineChartInstance.setOption(
                        {
                          legend: {
                            data: ["大果(特级果)", "中果(优质果)", "小果(精品果)"],
                            top: 10,
                            textStyle: { color: "#b6bcc7" },
                            itemWidth: 12,
                            itemHeight: 2,
                            itemGap: 20,
                          },
                          tooltip: {
                            trigger: "axis",
                            backgroundColor: "rgba(0, 11, 47, 0.9)",
                            borderColor: "rgba(6, 145, 237, 0.6)",
                            borderWidth: 1,
                            textStyle: {
                              color: "#ffffff",
                              fontSize: 12,
                            },
                            axisPointer: {
                              type: "cross",
                              lineStyle: {
                                color: "rgba(6, 145, 237, 0.8)",
                                width: 1,
                              },
                            },
                          },
                          xAxis: {
                            data: xAxisData,
                            axisLine: {
                              lineStyle: { color: "rgba(255,255,255,0.06)" },
                            },
                            axisLabel: { color: "#9fd7ff" },
                            splitLine: {
                              lineStyle: {
                                color: "rgba(255,255,255,0.03)",
                                type: "dashed",
                              },
                            },
                          },
                          yAxis: {
                            type: "value",
                            name: "单位：kg",
                            nameTextStyle: { color: "#9fbfff" },
                            axisLine: { show: false },
                            axisLabel: { color: "#9fd7ff" },
                            splitLine: {
                              lineStyle: {
                                color: "rgba(255,255,255,0.03)",
                                type: "dashed",
                              },
                            },
                          },
                          series: seriesData,
                        },
                        true
                      );
                    } catch (retryError) {
                      console.error("Chart update retry failed:", retryError);
                    }
                  }
                }, 100);
              }
            }
          });
        });
        this.chartUpdateTimer = null;
      }, 600); // 增加防抖延迟到 300ms
    },

    // 3D饼图相关方法
    getPie3D(pieData, internalDiameterRatio) {
      //internalDiameterRatio:透明的空心占比
      let that = this;
      let series = [];
      let sumValue = 0;
      let startValue = 0;
      let endValue = 0;
      let legendData = [];
      let legendBfb = [];
      let k = 1 - internalDiameterRatio;
      // 移除自动排序，保持用户指定的顺序
      // pieData.sort((a, b) => {
      //   return b.value - a.value;
      // });
      // 为每一个饼图数据，生成一个 series-surface 配置
      for (let i = 0; i < pieData.length; i++) {
        sumValue += pieData[i].value;
        let seriesItem = {
          name:
            typeof pieData[i].name === "undefined"
              ? `series${i}`
              : pieData[i].name,
          type: "surface",
          parametric: true,
          wireframe: {
            show: false,
          },
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k: k,
          },
          center: ["50%", "50%"],
        };

        if (typeof pieData[i].itemStyle != "undefined") {
          let itemStyle = {};
          typeof pieData[i].itemStyle.color != "undefined"
            ? (itemStyle.color = pieData[i].itemStyle.color)
            : null;
          typeof pieData[i].itemStyle.opacity != "undefined"
            ? (itemStyle.opacity = pieData[i].itemStyle.opacity)
            : null;
          seriesItem.itemStyle = itemStyle;
        }
        series.push(seriesItem);
      }

      // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
      // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
      legendData = [];
      legendBfb = [];
      for (let i = 0; i < series.length; i++) {
        endValue = startValue + series[i].pieData.value;
        series[i].pieData.startRatio = startValue / sumValue;
        series[i].pieData.endRatio = endValue / sumValue;
        series[i].parametricEquation = this.getParametricEquation(
          series[i].pieData.startRatio,
          series[i].pieData.endRatio,
          false,
          false,
          k,
          series[i].pieData.value
        );
        startValue = endValue;
        let bfb = that.fomatFloat(series[i].pieData.value / sumValue, 4);
        legendData.push({
          name: series[i].name,
          value: bfb,
        });
        legendBfb.push({
          name: series[i].name,
          value: bfb,
        });
      }
      let boxHeight = this.getHeight3D(series, 6); //通过传参设定3d饼/环的高度，减小高度适应新的容器尺寸
      // 准备待返回的配置项，把准备好的 legendData、series 传入。
      let option = {
        labelLine: {
          show: true,
          lineStyle: {
            color: "#7BC0CB",
          },
        },
        label: {
          show: true,
          position: "outside",
          rich: {
            b: {
              color: "#7BC0CB",
              fontSize: 12,
              lineHeight: 20,
            },
            c: {
              fontSize: 16,
            },
          },
          formatter: "{b|{b} \n}{c|{c}}{b|  条}",
        },
        tooltip: {
          formatter: (params) => {
            if (
              params.seriesName !== "mouseoutSeries" &&
              params.seriesName !== "pie2d"
            ) {
              let bfb = (
                (option.series[params.seriesIndex].pieData.endRatio -
                  option.series[params.seriesIndex].pieData.startRatio) *
                100
              ).toFixed(2);
              return (
                `${params.seriesName}<br/>` +
                `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>` +
                `${bfb}%`
              );
            }
          },
        },
        xAxis3D: {
          min: -1,
          max: 1,
        },
        yAxis3D: {
          min: -1,
          max: 1,
        },
        zAxis3D: {
          min: -1,
          max: 1,
        },
        grid3D: {
          show: false,
          boxHeight: boxHeight, //圆环的高度
          viewControl: {
            //3d效果可以放大、旋转等，请自己去查看官方配置
            alpha: 45, //角度
            distance: 250, //调整视角到主体的距离，类似调整zoom，调小使饼图看起来更大
            rotateSensitivity: 0, //设置为0无法旋转
            zoomSensitivity: 0, //设置为0无法缩放
            panSensitivity: 0, //设置为0无法平移
            autoRotate: false, //自动旋转
          },
        },
        series: series,
      };
      return option;
    },

    //获取3d丙图的最高扇区的高度
    getHeight3D(series, height) {
      series.sort((a, b) => {
        return b.pieData.value - a.pieData.value;
      });
      return (height * 25) / series[0].pieData.value;
    },

    // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      // 计算
      let midRatio = (startRatio + endRatio) / 2;
      let startRadian = startRatio * Math.PI * 2;
      let endRadian = endRatio * Math.PI * 2;
      let midRadian = midRatio * Math.PI * 2;
      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }
      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = typeof k !== "undefined" ? k : 1 / 3;
      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      let hoverRate = isHovered ? 1.05 : 1;
      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32,
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20,
        },
        x: function (u, v) {
          if (u < startRadian) {
            return (
              offsetX +
              Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            );
          }
          if (u > endRadian) {
            return (
              offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            );
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        y: function (u, v) {
          if (u < startRadian) {
            return (
              offsetY +
              Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            );
          }
          if (u > endRadian) {
            return (
              offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            );
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        z: function (u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * 0.1;
          }
          return Math.sin(v) > 0 ? 1 * h * 0.1 : -1;
        },
      };
    },

    fomatFloat(num, n) {
      var f = parseFloat(num);
      if (isNaN(f)) {
        return false;
      }
      f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂
      var s = f.toString();
      var rs = s.indexOf(".");
      //判定如果是整数，增加小数点再补0
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + n) {
        s += "0";
      }
      return s;
    },

    bindListen(myChart) {
      // 监听鼠标事件，实现饼图选中效果（单选），近似实现高亮（放大）效果。
      let that = this;
      let selectedIndex = "";
      let hoveredIndex = "";
      // 监听点击事件，实现选中效果（单选）
      myChart.on("click", function (params) {
        // 从 option.series 中读取重新渲染扇形所需的参数，将是否选中取反。
        let isSelected =
          !that.option.series[params.seriesIndex].pieStatus.selected;
        let isHovered =
          that.option.series[params.seriesIndex].pieStatus.hovered;
        let k = that.option.series[params.seriesIndex].pieStatus.k;
        let startRatio =
          that.option.series[params.seriesIndex].pieData.startRatio;
        let endRatio = that.option.series[params.seriesIndex].pieData.endRatio;
        // 如果之前选中过其他扇形，将其取消选中（对 option 更新）
        if (selectedIndex !== "" && selectedIndex !== params.seriesIndex) {
          that.option.series[selectedIndex].parametricEquation =
            that.getParametricEquation(
              that.option.series[selectedIndex].pieData.startRatio,
              that.option.series[selectedIndex].pieData.endRatio,
              false,
              false,
              k,
              that.option.series[selectedIndex].pieData.value
            );
          that.option.series[selectedIndex].pieStatus.selected = false;
        }
        // 对当前点击的扇形，执行选中/取消选中操作（对 option 更新）
        that.option.series[params.seriesIndex].parametricEquation =
          that.getParametricEquation(
            startRatio,
            endRatio,
            isSelected,
            isHovered,
            k,
            that.option.series[params.seriesIndex].pieData.value
          );
        that.option.series[params.seriesIndex].pieStatus.selected = isSelected;
        // 如果本次是选中操作，记录上次选中的扇形对应的系列号 seriesIndex
        isSelected ? (selectedIndex = params.seriesIndex) : null;
        // 使用更新后的 option，渲染图表
        myChart.setOption(that.option);
      });
      // 监听 mouseover，近似实现高亮（放大）效果
      myChart.on("mouseover", function (params) {
        // 准备重新渲染扇形所需的参数
        let isSelected;
        let isHovered;
        let startRatio;
        let endRatio;
        let k;
        // 如果触发 mouseover 的扇形当前已高亮，则不做操作
        if (hoveredIndex === params.seriesIndex) {
          return;
          // 否则进行高亮及必要的取消高亮操作
        } else {
          // 如果当前有高亮的扇形，取消其高亮状态（对 option 更新）
          if (hoveredIndex !== "") {
            // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 false。
            isSelected = that.option.series[hoveredIndex].pieStatus.selected;
            isHovered = false;
            startRatio = that.option.series[hoveredIndex].pieData.startRatio;
            endRatio = that.option.series[hoveredIndex].pieData.endRatio;
            k = that.option.series[hoveredIndex].pieStatus.k;
            // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
            that.option.series[hoveredIndex].parametricEquation =
              that.getParametricEquation(
                startRatio,
                endRatio,
                isSelected,
                isHovered,
                k,
                that.option.series[hoveredIndex].pieData.value
              );
            that.option.series[hoveredIndex].pieStatus.hovered = isHovered;
            // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
            hoveredIndex = "";
          }
          // 如果触发 mouseover 的扇形不是透明圆环，将其高亮（对 option 更新）
          if (
            params.seriesName !== "mouseoutSeries" &&
            params.seriesName !== "pie2d"
          ) {
            // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
            isSelected =
              that.option.series[params.seriesIndex].pieStatus.selected;
            isHovered = true;
            startRatio =
              that.option.series[params.seriesIndex].pieData.startRatio;
            endRatio = that.option.series[params.seriesIndex].pieData.endRatio;
            k = that.option.series[params.seriesIndex].pieStatus.k;
            // 对当前点击的扇形，执行高亮操作（对 option 更新）
            that.option.series[params.seriesIndex].parametricEquation =
              that.getParametricEquation(
                startRatio,
                endRatio,
                isSelected,
                isHovered,
                k,
                that.option.series[params.seriesIndex].pieData.value + 5
              );
            that.option.series[params.seriesIndex].pieStatus.hovered =
              isHovered;
            // 记录上次高亮的扇形对应的系列号 seriesIndex
            hoveredIndex = params.seriesIndex;
          }
          // 使用更新后的 option，渲染图表
          myChart.setOption(that.option);
        }
      });
      // 修正取消高亮失败的 bug
      myChart.on("globalout", function () {
        // 准备重新渲染扇形所需的参数
        let isSelected;
        let isHovered;
        let startRatio;
        let endRatio;
        let k;
        if (hoveredIndex !== "") {
          // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
          isSelected = that.option.series[hoveredIndex].pieStatus.selected;
          isHovered = false;
          k = that.option.series[hoveredIndex].pieStatus.k;
          startRatio = that.option.series[hoveredIndex].pieData.startRatio;
          endRatio = that.option.series[hoveredIndex].pieData.endRatio;
          // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
          that.option.series[hoveredIndex].parametricEquation =
            that.getParametricEquation(
              startRatio,
              endRatio,
              isSelected,
              isHovered,
              k,
              that.option.series[hoveredIndex].pieData.value
            );
          that.option.series[hoveredIndex].pieStatus.hovered = isHovered;
          // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
          hoveredIndex = "";
        }
        // 使用更新后的 option，渲染图表
        myChart.setOption(that.option);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.harvest-container {
  width: 100%;
  height: 100vh;
  background: #030a2e;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.stats-section {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: space-between;
}

.stat-card {
  width: 445px;
  background: rgba(0, 32, 67, 0.6);
  border: 1px solid rgba(6, 145, 237, 0.6);
  box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
  border-radius: 4px;
  padding: 15px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 180px;
}

/* 当卡片包含 3D 图时的布局调整 */
.stat-card.donut-card {
  display: flex;
  align-items: center;
  padding: 0;
  justify-content: center;
}

.stat-card.donut-card .stat-header {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.donut3d-card {
  width: 445px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* HTML labels and connector lines for 3D donut */
/* keep original visual solely via echarts option, no HTML overlay labels */

.stat-header {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
}

.stat-icon-wrapper {
  width: 130px;
  height: 125px;
  display: flex;
  align-items: center;
  justify-content: center;

  .stat-icon img {
    width: 130px;
    height: 125px;
    object-fit: contain;
    filter: drop-shadow(0 0 6px rgba(149, 210, 240, 0.9));
  }
}

.stat-info {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.stat-info .stat-label {
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  margin-bottom: 6px;
}

.stat-info .stat-value {
  font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
  font-weight: 400;
  font-size: 50px;
  color: #ffffff;
  text-shadow: 0px 0px 21px #0691ed;
  text-align: left;
  font-style: normal;
}

.donut-wrapper {
  width: 400px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.donut3d-card {
  width: 445px;
  height: 180px;
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(-80px);
}

.main-content {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  height: calc(100vh - 156px - 250px);
}

.panel-card {
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: calc(100vw - 60px - 30px - 550px - 370px);
}

.left-panel {
  flex: 1;
  padding: 18px;
}

.right-panel {
  padding: 18px;
}

.section-title {
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  padding-left: 10px;
}

.harvest-table {
  padding: 12px;
  flex: 1;
  overflow-y: auto;
}

.harvest-table table {
  width: 100%;
  border-collapse: collapse;
  color: #dbe9ff;
  background: rgba(4, 56, 111, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 6px;
  overflow: hidden;
  table-layout: fixed;
}

.harvest-table th {
  text-align: left;
  padding: 12px 8px;
  font-size: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  background-color: #005bba;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.harvest-table td {
  text-align: left;
  padding: 12px 8px;
  font-size: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.harvest-table th:last-child,
.harvest-table td:last-child {
  border-right: none;
}

/* 列宽调整：第1列（大棚编号）窄些，第2列（产品名称）和第5列（商品果占比）宽些 */
.harvest-table th:nth-child(1),
.harvest-table td:nth-child(1) {
  width: 20%;
  min-width: 100px;
}

.harvest-table th:nth-child(2),
.harvest-table td:nth-child(2) {
  width: 20%;
  min-width: 160px;
}

.harvest-table th:nth-child(3),
.harvest-table td:nth-child(3) {
  width: 16%;
  text-align: center;
}

.harvest-table th:nth-child(4),
.harvest-table td:nth-child(4) {
  width: 16%;
  text-align: center;
}

.harvest-table th:nth-child(5),
.harvest-table td:nth-child(5) {
  width: 26%;
}

/* 固定表头：thead 的 th 在滚动容器内固定到顶部 */
.harvest-table thead th {
  position: sticky;
  top: 0;
  z-index: 12;
  /* 保持表头背景与边框一致，避免透出下面内容 */
  background-color: #005bba;
  box-shadow: 0 2px 6px rgba(1, 22, 50, 0.25);
}

/* 当表格为空时，table 可能不显示，确保空状态仍保持正常布局 */
.harvest-table .table-empty {
  position: relative;
  z-index: 1;
}

.progress-wrap {
  position: relative;
  background: rgba(255, 255, 255, 0.04);
  height: 18px;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #06d6a0, #0691ed);
}

.progress-text {
  position: absolute;
  right: 8px;
  top: 0;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #fff;
  font-weight: 600;
}

.table-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 36px 0;
  color: #7fb4ff;
}

/* 状态行数值颜色区分：normal 为正向（绿色），locked 为负向（红色） */
.status-item .status-label {
  margin-right: 8px;
  color: #cfefff;
  font-size: 12px;
}

.status-item .status-value {
  font-size: 12px;
}

.status-item.normal .status-value {
  color: #06d6a0;
}

.status-item.locked .status-value {
  color: #ff7b7b;
}

/* 总采收量卡片专用样式：仅显示左侧大号百分比与右侧标签（如图） */
.stat-card.summary-card .stat-footer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding-top: 6px;
}

.stat-card.summary-card .status-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stat-card.summary-card .status-value {
  font-size: 18px;
  font-weight: 400;
  color: #04ff9f;
  line-height: 1;
}

.stat-card.summary-card .status-label {
  font-size: 16px;
  color: #cfefff;
  font-weight: 500;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  margin-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.chart-area {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  position: relative;
}

.donut3d {
  width: 180px;
  height: 180px;
  flex-shrink: 0;
  margin-right: 12px;
}

.line-chart {
  flex: 1;
  height: 450px;
  min-width: 240px;
}

.line-chart.chart-hidden {
  visibility: hidden;
}

.chart-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(3, 10, 46, 0.8);
  z-index: 10;
}

.chart-placeholder {
  width: 100%;
  height: 300px;
  border-radius: 6px;
  background: linear-gradient(180deg,
      rgba(4, 54, 99, 0.4),
      rgba(2, 30, 60, 0.2));
  color: #9fd7ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dataTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 30px;
}

.time-dimension {
  display: inline-flex;
  gap: 12px;

  align-items: center;
}

.time-btn {
  min-width: 100px;
  height: 40px;
  border-radius: 6px;
  background: transparent;
  border: 1px dashed rgba(159, 215, 255, 0.22);
  color: rgba(255, 255, 255, 0.45);
  font-size: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  transition: all 0.18s ease;
  box-shadow: none;
}

.time-btn:hover {
  color: #dff7ff;
}

.time-btn.active {
  color: #ffffff;
  border: 1px solid rgba(6, 145, 237, 0.9);
  box-shadow: inset 0 0 18px rgba(6, 145, 237, 0.35),
    inset 0 0 8px rgba(6, 145, 237, 0.12);
  text-shadow: 0 0 8px rgba(9, 150, 235, 0.8);
  background: linear-gradient(180deg,
      rgba(6, 145, 237, 0.06),
      rgba(2, 55, 110, 0.02));
}

.databox {
  margin: 10px;
  width: calc(100vw - 40px);
  height: calc(100vh - 98px);
  background: rgba(0, 11, 47, 0.5);
  box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
  border-radius: 0px 0px 0px 0px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.time-label {
  font-weight: 400;
  font-size: 16px;
  color: #b6bcc7;
  width: 80px;
  margin-left: 20px;
}

.top-filters {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
